import { type SendOut } from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';
import { sendOutFilters } from '@/app/settings/modules/communication/send-out-templates/filters';
import { Badge } from '@/components/ui/badge';

export const SendOutItem: RelationFieldProps<SendOut> = {
  filters: sendOutFilters,
  renderItem: (item) => ({
    title: `${item?.name}`,
    badge: (
      <Badge variant='outline' className='h-fit'>
        {item.isTemplate ? 'Mall' : 'Utskick'}
      </Badge>
    ),
    descriptionItems: <></>,
  }),
};
